import React from "react";
import Content from "../common/Content";
import HeaderWithIntro from "../common/HeaderWithIntro";
import styled from "styled-components";
import { colors, spacing } from "../theme";
import Label from "../common/Label";
import Button from "../common/Button";
import { ContentRef, Category } from "../../lib/CmsApi";
import SimpleInformationCard from "../common/SimpleInformationCard";
import Grid from "../common/Grid";

const StyledCard = styled(SimpleInformationCard)<{ external?: boolean }>`
  /* box-shadow: 0 4px 4px 0 ${colors.cloudyBlue}; */
  background: ${p => (p.external ? colors.paleGreyTwo : colors.lightGrey)};
`;
const StyledLabel = styled(Label)`
  ${spacing("margin-bottom", 24)}
`;
const StyledGrid = styled(Grid)`
  ${spacing("margin-bottom", 64)}
`;
interface Props {
  category: ContentRef & Category;
  categorySlug: string;
  segmentSlug: string;
}

export default function CategoryTeaser(props: Props) {
  const { category: cat, categorySlug, segmentSlug } = props;

  if (!cat.programs) return null;
  const cards = [
    ...cat.programs.slice(0, 3).map((program: any, idx) => {
      //TODO: fix as any
      if ("ctaHref" in program) {
        return (
          <StyledCard
            key={idx}
            noBorder
            text={program.name}
            label={program.type.name}
            href={program.ctaHref}
          />
        );
      }
      if (!("slug" in program)) return null;
      return (
        <StyledCard
          key={idx}
          noBorder
          route="program"
          text={program.name}
          label={program.type.name}
          params={{
            category: cat.slug,
            categoryCluster: categorySlug,
            segment: segmentSlug,
            slug: program.slug
          }}
          external
        />
      );
    }),
    cat.programs.length > 3 && (
      <StyledCard
        key={3}
        route="category"
        noBorder
        text="+ Weitere"
        params={{
          category: cat.slug,
          categoryCluster: categorySlug,
          segment: segmentSlug
        }}
      />
    )
  ];

  return (
    <Content padded>
      <HeaderWithIntro
        headline={cat.name}
        intro={cat.subheader.intro}
        overline="Was haben Sie vor?"
        serif
      />
      {cat.programs && cat.programs.length > 0 && (
        <>
          <StyledLabel small>
            So unterstützen wir Sie:
          </StyledLabel>
          <StyledGrid
            columns={4}
            tabletColumns={3}
            mobileColumns={2}
            tinyColumns={1}
            trimElements
            columnGap="2%"
          >
            {cards}
          </StyledGrid>
        </>
      )}
      <Button
        alignCenter
        route="category"
        params={{
          category: cat.slug,
          categoryCluster: categorySlug,
          segment: segmentSlug
        }}
        aria-label={`Mehr erfahren über "${cat.name}"`}
      >
        Mehr erfahren
      </Button>
    </Content>
  );
}
